import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { TabView, TabPanel } from 'primereact/tabview';
import StyleStripeDetails from './StyleStripeDetails';

const StyleStripeView = () => {
    const [activeStripeTabIndex, setActiveStripeTabIndex] = useState<number>(0);
    const { styleCode } = useParams();

    useEffect(() => {
        if (!styleCode) { return; }
    }, [styleCode]);

    return (
        <div className="grid-nogutter">
            <div className="col-12">
                <TabView activeIndex={activeStripeTabIndex} onTabChange={(e) => setActiveStripeTabIndex(e.index)}>
                    <TabPanel header="A" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'A'} />
                    </TabPanel>
                    <TabPanel header="B" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'B'} />
                    </TabPanel>
                    <TabPanel header="C" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'C'} />
                    </TabPanel>
                    <TabPanel header="D" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'D'} />
                    </TabPanel>
                    <TabPanel header="E" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'E'} />
                    </TabPanel>
                    <TabPanel header="F" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'F'} />
                    </TabPanel>
                    <TabPanel header="G" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'G'} />
                    </TabPanel>
                    <TabPanel header="H" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'H'} />
                    </TabPanel>
                    <TabPanel header="I" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'I'} />
                    </TabPanel>
                    <TabPanel header="J" headerStyle={{display: 'block'}}>
                        <StyleStripeDetails style={styleCode} sequence={activeStripeTabIndex+1} stripeSequence={'J'} />
                    </TabPanel>
                </TabView>
            </div>
        </div>
    );
};

export default StyleStripeView;